import axiosConfig from './axiosConfig';

export const userApi = {
  getAll: async (params = {}) => {
    const response = await axiosConfig.get('/users', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosConfig.get(`/users/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosConfig.put(`/users/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosConfig.delete(`/users/${id}`);
    return response.data;
  },

  changePassword: async (data) => {
    const response = await axiosConfig.post('/users/change-password', data);
    return response.data;
  },
};